import { render } from "./BirthSilos.vue?vue&type=template&id=66885757&scoped=true"
import script from "./BirthSilos.vue?vue&type=script&lang=js"
export * from "./BirthSilos.vue?vue&type=script&lang=js"

import "./BirthSilos.vue?vue&type=style&index=0&id=66885757&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66885757"]])

export default __exports__